module.exports = __webpack_public_path__ + "img/nav-setting.99ff325c.svg";